/**
 * O fuso da pessoa e identificador IANA, e o cliente confere isso antes de
 * enviar.
 *
 * A §2.2 guarda o fuso como identificador IANA e TODA formatacao de data passa
 * por ele (`i18n/datetime.ts`). Um valor sintaticamente plausivel e inexistente
 * — "Brasilia", "GMT-3", "America/Sao paulo" — nao e recusado pela EDICAO do
 * cadastro no servidor, que so verifica se o campo veio vazio; a partir do
 * momento em que ele e gravado, `new Intl.DateTimeFormat(..., { timeZone })`
 * lanca `RangeError` em qualquer tela que formate data daquela pessoa. Como a
 * SPA nao tem `ErrorBoundary`, o erro derruba a arvore inteira: pagina branca,
 * sem cabecalho, sem menu e sem saida.
 *
 * A verificacao e o proprio `Intl`, e nao uma lista escrita a mao: a lista de
 * fusos muda por decisao de governo (o Brasil mesmo ja apagou dois), e uma
 * copia nossa envelheceria calada. O navegador carrega a base do ICU, que e a
 * mesma familia de dados que o `time.LoadLocation` do servidor consulta.
 *
 * Isto NAO substitui a validacao do servidor — cliente nenhum e barreira. O que
 * ele fecha e o unico caminho pelo qual a SPA hoje grava um fuso invalido.
 */
export function isValidTimezone(value: string): boolean {
  const candidate = value.trim();
  if (candidate === '') return false;

  try {
    new Intl.DateTimeFormat(undefined, { timeZone: candidate });
    return true;
  } catch {
    // `RangeError` e a resposta do `Intl` para fuso desconhecido. Qualquer
    // outra excecao aqui tambem significa "nao da para formatar com isso", que
    // e a mesma decisao.
    return false;
  }
}
